export const isImageUrl = (url) => {
  // Check if the splashScreenBg starts with "http" to determine if it's an image URL
  return url && (url.startsWith("http://") || url.startsWith("https://"));
};
